import type { ReactNode } from "react";
import {
  Drawer,
  Stack,
  Text,
  Group,
  Divider,
  ScrollArea,
} from "@mantine/core";

// Reusable right-hand detail drawer. Each list page composes its own content
// (use DetailField / DetailSection for a consistent key/value layout).
export function DetailDrawer({
  opened,
  onClose,
  title,
  children,
}: {
  opened: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
}) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size="lg"
      title={
        <Text fw={700} fz="lg">
          {title}
        </Text>
      }
      scrollAreaComponent={ScrollArea.Autosize}
      padding="lg"
    >
      <Stack gap="md">{children}</Stack>
    </Drawer>
  );
}

export function DetailSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <Stack gap="xs">
      <Divider
        label={
          <Text size="xs" fw={700} tt="uppercase" c="dimmed">
            {title}
          </Text>
        }
        labelPosition="left"
      />
      <Stack gap={8}>{children}</Stack>
    </Stack>
  );
}

export function DetailField({
  label,
  value,
}: {
  label: string;
  value: ReactNode;
}) {
  return (
    <Group justify="space-between" wrap="nowrap" align="flex-start" gap="xl">
      <Text size="sm" c="dimmed" style={{ flexShrink: 0 }}>
        {label}
      </Text>
      <Text size="sm" fw={500} ta="right" style={{ wordBreak: "break-word" }}>
        {value ?? "—"}
      </Text>
    </Group>
  );
}
